import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaGithub, FaLinkedin } from "react-icons/fa";

import { Div, DivMenuHeight, SNav, SocialNetwork } from '../../styles/components/Nav';
import theme from '../../styles/theme';

type LinkType = {
    onClick: () => void
}

type LocalLinkType = {
    hash: string,
    title: string,
    scroll: number,
    element: string,
    onClick: () => void
}

const LocalLink = ({ hash, title, scroll, element, onClick }: LocalLinkType) => {

    const ref = useRef<HTMLAnchorElement>(null);

    useEffect(() => {

        const domElement = document.getElementById(element);
        const start = domElement?.offsetTop;
        const stop = domElement?.offsetHeight;
        if (stop && start) {
            if (scroll < (stop - 120 + start) && scroll >= (start - 120)) {
                ref.current?.classList.add('active');
            } else {
                ref.current?.classList.remove('active');
            }
        }
    }, [scroll]); // eslint-disable-line



    return (
        <Link
            to={{ pathname: '/', hash: hash }}
            ref={ref}
            onClick={onClick}
        >
            {title}
        </Link>
    );
}

const Links = ({ onClick }: LinkType) => {

    const [scrollY, setScrollY] = useState(0);
    const location = useLocation();

    useEffect(() => {

        const onScroll = () => setScrollY(window.scrollY);

        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => window.removeEventListener('scroll', onScroll);

    }, []);


    useEffect(() => {
        if (location.hash) {
            let elem = document.getElementById(location.hash.slice(1))
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth" })
            }
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
        }

    }, [location])


    return (
        <nav>
            <ul>
                <li>
                    <LocalLink
                        title='Home'
                        hash='#home'
                        scroll={scrollY}
                        element={'home'}
                        onClick={onClick}
                    />
                </li>
                <li>
                    <LocalLink
                        title='Sobre'
                        hash='#about'
                        scroll={scrollY}
                        element={'about'}
                        onClick={onClick}
                    />
                </li>
                <li>
                    <LocalLink
                        title='Currículo'
                        hash='#resume'
                        scroll={scrollY}
                        element={'resume'}
                        onClick={onClick}
                    />
                </li>
                <li>
                    <LocalLink
                        title='Portifólio'
                        hash='#portifolio'
                        scroll={scrollY}
                        element={'portifolio'}
                        onClick={onClick}
                    />

                </li>
                <li>
                    <LocalLink
                        title='Contato'
                        hash='#contact'
                        scroll={scrollY}
                        element={'contact'}
                        onClick={onClick}
                    />

                </li>
                {/* <li>
                    <Link to={'#'} onClick={onClick}>
                        Blog
                    </Link>
                </li> */}
                <li>
                    <SocialNetwork>
                        <a href="https://github.com/patrickassuncao1" target="_blank" rel="noreferrer">
                            <FaGithub size={25} />
                        </a>
                        <a href="https://www.linkedin.com/in/patrick-assunção" target="_blank" rel="noreferrer">
                            <FaLinkedin size={25} />
                        </a>
                    </SocialNetwork>
                </li>
            </ul>
        </nav>
    )
}

const Nav: React.FC = () => {
    const [menuIsActive, setMenuIsActive] = useState(false);


    const MenuMobile = () => {
        return menuIsActive ? <FaTimes size={25} /> : <FaBars size={25} />

    }

    const closeMenu = () =>{ 
        setMenuIsActive(false);
    }

    const menuControl = () => {
        setMenuIsActive(!menuIsActive);
    }

    return (
        <>
            <DivMenuHeight />
            <SNav
                backgroundColor={theme.colors.primary}
                minHeight={menuIsActive ? "95vh" : "0"}
                opacity={menuIsActive ? "1" : "0"}
            >
                <Div overflow={menuIsActive ? "visible" : "hidden"}>
                    <div className='header-box'>
                        <div className='picture'>
                            <div >
                                <img src="/img/avatar.png" alt="" />
                            </div>
                            <span>Patrick Assunção</span>
                        </div>
                        <Links onClick={closeMenu} />
                        <button className='menu-btn-mobile' onClick={menuControl}>
                            <MenuMobile />
                        </button>
                    </div>
                </Div>

            </SNav>
        </>

    );
}

export default Nav;